<div class="row no-gutters">
    <div class="col-12">
        <mat-card class="mb-3"
                  [ngClass]="{'focused-result': focused }">

            <div class="row no-gutters">
                <div class="col-12">
                    <div class="result-title smp-title-thin-border full-width mb-3">
                        {{ resultTitle | translate }}
                        <button id="{{idPrefix}}btn.delete"
                                mat-icon-button
                                class="delete-btn"
                                (click)="removeFurtherResult()"
                                [disabled]="disabled">
                            <mat-icon class="dr-material-icon"
                                      [ngClass]="{ 'disabled': disabled }"
                                      matTooltip="{{ 'common.label.delete' | translate }}">clear
                            </mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col-10">
                    <mat-form-field #mffResultType class="full-width">
                        <mat-label>{{ result.trans.result_type_id | translate }}</mat-label>
                        <mat-select id="{{idPrefix}}{{result.trans.result_type_id}}"
                                    [(ngModel)]="selectedResultType"
                                    (ngModelChange)="onResultTypeChange()"
                                    [disabled]="disabled">
                            <mat-option *ngFor="let resultType of availableResultTypesAndMine"
                                        id="{{idPrefix}}{{result.trans.result_type_id}}.{{resultType.key}}"
                                        [value]="resultType">
                                {{ resultType.trans | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-2"></div>
            </div>

            <div class="row no-gutters" *ngIf="!result.showGroupFields">
                <div class="col-10">
                    <mat-form-field #mffNet class="full-width with-calc-button">
                        <mat-label>{{ result.trans.net | translate }}</mat-label>
                        <input id="{{idPrefix}}{{result.trans.net}}"
                               type="text" matInput currency
                               [(ngModel)]="result.net"
                               (blur)="patchAndUpdate('net')"
                               [disabled]="disabled || !result.result_type_id">
                        <button id="{{idPrefix}}{{result.trans.net}}.btn.calculate"
                                mat-button
                                matSuffix mat-icon-button
                                (click)="calculate('gross', 'net')"
                                [disabled]="!vehicleTaxPercentage || !result.net">
                            <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.GROSS) | translate">
                                <i class="fas fa-calculator"></i>
                            </mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="col-2 align-self-center pl-4">
                    {{ currency.currency_display_name }}
                </div>
            </div>

            <div class="row no-gutters" *ngIf="!result.showGroupFields">
                <div class="col-10">
                    <mat-form-field #mffTax class="full-width">
                        <mat-label>{{ result.trans.tax | translate }}</mat-label>
                        <input id="{{idPrefix}}{{result.trans.tax}}"
                               type="text" matInput currency
                               [(ngModel)]="result.tax"
                               (blur)="patchAndUpdate('tax')"
                               [disabled]="disabled || !result.result_type_id">
                    </mat-form-field>
                </div>

                <div class="col-2 align-self-center pl-4">
                    {{ currency.currency_display_name }}
                </div>
            </div>

            <div class="row no-gutters" *ngIf="result.showGroupFields">
                <div class="col-10">
                    <mat-form-field #mffGroup class="full-width">
                        <mat-label>{{ result.trans.group | translate }}</mat-label>
                        <input id="{{idPrefix}}{{result.trans.group}}"
                               type="text" matInput
                               [(ngModel)]="result.group"
                               (blur)="patchAndUpdate('group')"
                               [disabled]="disabled || !result.result_type_id">
                    </mat-form-field>
                </div>

                <div class="col-2 align-self-center pl-4"></div>
            </div>

            <div class="row no-gutters">
                <div class="col-10">
                    <mat-form-field #mffGross class="full-width with-calc-button">
                        <mat-label>{{ result.grossLabel | translate }}</mat-label>
                        <input id="{{idPrefix}}{{result.grossLabel}}"
                               type="text" matInput currency
                               [(ngModel)]="result.gross"
                               (blur)="patchAndUpdate('gross')"
                               [disabled]="disabled || !result.result_type_id">
                        <button id="{{idPrefix}}{{result.grossLabel}}.btn.calculate"
                                mat-button
                                matSuffix mat-icon-button
                                *ngIf="!result.showGroupFields"
                                (click)="calculate('net', 'gross')"
                                [disabled]="!vehicleTaxPercentage || !result.gross">
                            <mat-icon [matTooltip]="getToolTip(VatCalculationEnum.NET) | translate">
                                <i class="fas fa-calculator"></i>
                            </mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="col-2 align-self-center pl-4">
                    {{ result.showGroupFields ? ('common.label.currency_per_day' | translate : { currency: currency.currency_display_name }) : currency.currency_display_name }}
                </div>
            </div>

            <div class="row no-gutters" [ngStyle]="{ 'margin-top': result.showGroupFields ? '56.5625px' : '' }">
                <div class="col-10">
                    <mat-form-field #mffComment class="full-width">
                        <mat-label>{{ result.trans.comment | translate }}</mat-label>
                        <textarea id="{{idPrefix}}{{result.trans.comment}}"
                                  matInput
                                  rows="3"
                                  [(ngModel)]="result.comment"
                                  (blur)="patchAndUpdate('comment')"
                                  [disabled]="disabled || !result.result_type_id">
                        </textarea>
                    </mat-form-field>
                </div>

                <div class="col-2"></div>
            </div>

        </mat-card>
    </div>
</div>
